export default "__VITE_ASSET__3b8cb6a8__"